import React, { useEffect, useState } from 'react'
import withIsInViewport from '../hooks/withIsInViewport'
import { trackAdvertisementView } from '../tracking'
import AdvertisementLinkWrapper from '../Advertisements/AdvertisementLinkWrapper'
import AdvertisementImages from '../Advertisements/AdvertisementImages'


const SliderBasicItemAdvertisement = ({index, data, isMobile, currentSlideInViewport, isInViewport, refElemViewport}) => {
    const imageURLs = {
        desktop: false,
        mobile: false
    }

    const eventOrigin = 'Main Slider'
    const className = isMobile ? 'custom-placement-slider-mobile-container custom-placement-item' : "image-wrapper slider-basic slider-basic-large custom-placement-item"

    const [wasInViewport, setIsInViewport] = useState(false)

    useEffect(() => {
        if(!wasInViewport && isInViewport && currentSlideInViewport)  {
            setIsInViewport(true)
        }
    }, [isInViewport, currentSlideInViewport])

    useEffect(() => {
        if(wasInViewport)  {
            trackAdvertisementView(eventOrigin, data.pk, data.title)
        }

    }, [wasInViewport])

    return (
        <div key={index} className={className}>
            <AdvertisementLinkWrapper 
                refElemViewport={refElemViewport}
                item={data}
                eventOrigin={eventOrigin}
            >
                <AdvertisementImages
                    images={data.images} 
                    imageURLs={imageURLs}
                    imgTag={true}
                />
            </AdvertisementLinkWrapper>
        </div>
    )
}

export default withIsInViewport(SliderBasicItemAdvertisement)